import React, { useCallback, useEffect } from 'react';
import { toast } from 'react-toastify';

import { isEmpty, isArray } from 'lodash';
import PropTypes from 'prop-types';

import { t } from '~/helpers';
import api from '~/services/api';

export default function Maintenance({ tank, sending, close }) {
  const handleChangeMaintenance = useCallback(async () => {
    try {
      await api.put('estoquestanquespostoscomboios', {
        ...tank.graphic,
        manutencaotanquefisico: tank.em_manutencao ? 'N' : 'M',
      });

      toast.success(t('c.menu.stock.acaomanutencao.sucesso'));

      close();
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, [tank]);

  useEffect(() => {
    if (sending) handleChangeMaintenance();
  }, [sending]);

  if (!isEmpty(tank))
    return (
      <>
        {tank.em_manutencao
          ? t('c.menu.stock.acaomanutencao.retiramanutencao').replace(
              '%s',
              `${tank.tafi_codigo} (${tank.prod_display})`
            )
          : t('c.menu.stock.acaomanutencao.colocamanutencao').replace(
              '%s',
              `${tank.tafi_codigo} (${tank.prod_display})`
            )}
      </>
    );

  return '';
}

Maintenance.propTypes = {
  tank: PropTypes.objectOf(PropTypes.any).isRequired,
  sending: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};
